import { PHOTO_DESCRIPTION } from "../constants"

class DescriptionElement {
  constructor(element) {
    this.element = element
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_DESCRIPTION)
    return element ? new DescriptionElement(element) : null
  }

  apply(photo) {
    if (!this.element) return
    if (!photo.description) {
      this.element.textContent = ""
      return
    }

    // Update description text content
    // Note: We're using textContent to avoid XSS, matching the server-side h_cond helper behavior
    this.element.textContent = photo.description
  }
}

export default DescriptionElement
